import { render, staticRenderFns } from "./addReserv.vue?vue&type=template&id=170abc38&scoped=true"
import script from "./addReserv.vue?vue&type=script&lang=js"
export * from "./addReserv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170abc38",
  null
  
)

export default component.exports